import React from 'react';

type Props = {
  label: string;
  children?: React.ReactNode;
};

export default function DescriptionRow({ label, children }: Props) {
  if (React.Children.count(children) === 0) {
    return <></>;
  }
  return (
    <div className=" sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 md:gap-2 flex flex-col md:flex-row  justify-center md:items-end">
      <dd className="text-sm font-medium text-gray-500">{label}</dd>
      <dd className=" text-sm text-gray-900 sm:mt-0 sm:col-span-2">
        {children}
      </dd>
    </div>
  );
}
